// @owners { team: patient-health }
// This is now a legacy component that will be removed in favor of ItemPricing.tsx
// when the Improved Pricing & Savings Attribution experiment is fully implemented.
import { Description, XxsSpacing } from '@alto/design-system';
import React from 'react';
import { PricingInfoRow } from '../../pricing-info/components/PricingInfoRow';

type Props = {
  readonly label: string;
  readonly price: string;
  readonly helperText: string;
};

export const PricingBreakdownRxLineItemWithoutInsurance = ({ label, price, helperText }: Props) => (
  <>
    <PricingInfoRow
      label={label}
      price={price}
    />
    <XxsSpacing />
    <Description>{helperText}</Description>
  </>
);
